<template>
  <div>
    <div class=" d-flex justify-center px-4 py-3">
      <v-img
        :src="logoUrl"
        class="logo"
      />
    </div>
    <v-divider class="divider" />
  </div>
</template>

<script>
export default {
  name: 'SidebarLogoMenu',

  computed: {
    logoUrl() {
      const customLogoUrl = localStorage.getItem('user_logo_url')
      const hausefulLogo = require('@/assets/images/logohauseful.svg')

      return customLogoUrl ? customLogoUrl : hausefulLogo
    }
  }
}
</script>

<style scoped>
  .logo {
    max-width: 40px !important;
    max-height: 40px !important;
  }

  .divider {
    opacity: 0.3;
  }
</style>
